import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

const Main = (props) => {

    {/*
    Documentation
        Props:
            active={false/true} - Swaps default styling to active - False by default
            default={false/true} - Enables default styles entirely - True by default ***STYLE MUST BE SET FOR DEFAULT TO BE SET TO FALSE***
            Style={...styles} - Passthrough to styles for complete control - empty by default
            onClick={function()} - passthrought to onClick to callback a function - empty by default
            children={'string'} - Text on button
    */}

    const parseDateString = (value) => {
        if (!value) return null

        const [year, month, day] = value.split('-').map(Number)
        if (!year || !month || !day) return null

        return new Date(year, month - 1, day)
    }

    const formatDateForDisplay = (date) => {
        if (!(date instanceof Date) || Number.isNaN(date.getTime())) return ''

        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const year = String(date.getFullYear()).slice(-2)

        return `${month}/${day}/${year}`
    }

    const getDisplayLabel = () => {
        if (!props.calStartDate || !props.calEndDate) return 'Select Week | All Times'

        const isDefaultStart = props.calStartDate === '2000-01-01'
        const isDefaultEnd = props.calEndDate === '2200-01-01'

        const startDate = parseDateString(props.calStartDate)
        const endDate = parseDateString(props.calEndDate)

        const displayStart = startDate ? new Date(startDate) : null
        const displayEnd = endDate ? new Date(endDate) : null

        if (displayStart) {
            displayStart.setDate(displayStart.getDate() + 3)
        }

        if (displayEnd) {
            displayEnd.setDate(displayEnd.getDate() - 3)
        }

        const startLabel = displayStart ? formatDateForDisplay(displayStart) : ''
        const endLabel = displayEnd ? formatDateForDisplay(displayEnd) : 'All Times'

        if (isDefaultStart && isDefaultEnd) {
            return `Select Week | All Times`
        }

        if (isDefaultStart) {
            return `Select Week | ${endLabel}`
        }

        if (isDefaultEnd) {
            return `${startLabel} | Select Week | All Times`
        }

        return `${startLabel} | Select Week | ${endLabel}`
    }

    const defaultStyle = 
        props.active ? 
        {
            display: 'block',
            backgroundColor: props.colors.primary,
            paddingLeft: '20px',
            paddingRight: '20px',
            borderRadius: '10000px',
            color: props.colors.fontInvert,
            fontWeight: '500',
            height: '100%',
            minHeight: '30px',
            maxHeight: '40px',
        }
        :
        {
            display: 'block',
            backgroundColor: props.colors.block,
            paddingLeft: '20px',
            paddingRight: '20px',
            borderRadius: '10000px',
            border: '1px solid ' + props.colors.border,
            color: props.colors.font,
            fontWeight: '500',
            height: '100%',
            minHeight: '30px',
            maxHeight: '40px',
        }

    return (
        <motion.button onClick={props.onClick} whileHover={{scale: 1.03}} style={props.Style === undefined ? defaultStyle:props.default === undefined ? {...defaultStyle, ...props.Style}:props.Style}>
            <span>{getDisplayLabel()}</span>
        </motion.button>
    )
}

export default Main
